import { render } from "./Banner.vue?vue&type=template&id=70e79c0a&scoped=true"
const script = {}

import "./Banner.vue?vue&type=style&index=0&id=70e79c0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e79c0a"]])

export default __exports__